import { render } from 'preact';
import { getServiceContentById, getServicesByCartId } from '@/api';
import { CSS_PATH } from '@/constants';
import { createScopedStylesheet } from '@/helpers/dom';
import {
  createDialogShadowPortal,
  createWidgetShadowRoot,
} from '@/helpers/shadow-root';
import { validateNotExcludedItem } from '@/helpers/validate';
import { log } from '@/utils';

import { CartRootWidget } from './cart-root-widget';

export async function mountCartWidget() {
  const cart_id = window.itsServices.cartId;
  const [styles, serviceContentById] = await Promise.all([
    createScopedStylesheet(CSS_PATH),
    getServiceContentById(),
  ]);

  if (!serviceContentById || !styles || !cart_id) return;

  const offerings = await getServicesByCartId(cart_id);
  if (!offerings?.length) return;

  const mountEls = document.querySelectorAll('[data-its-services]');
  if (!mountEls) return;

  createDialogShadowPortal(styles);

  mountEls.forEach((el) => {
    const itemId = el.getAttribute('data-item-id');
    if (!itemId) return;

    const serviceOffering = getServiceByItemId(offerings, itemId);
    console.log('🚀 ~ mountCartWidget ~ serviceOffering:', serviceOffering);
    if (!serviceOffering) return;

    applyLabelToAppliedOffers(el, serviceOffering);

    const unAppliedServices = getUnappliedServices(serviceOffering);
    if (!unAppliedServices.services.length) return;

    const productExclusionCheck = validateNotExcludedItem(el.id, 'data-name');
    if (!productExclusionCheck.ok) return log.warn(productExclusionCheck.msg);

    const root = createWidgetShadowRoot(el.id, styles);

    if (!root) return;

    render(
      <CartRootWidget
        serviceContentById={serviceContentById}
        cartItemDetails={unAppliedServices}
        cartId={cart_id}
      />,
      root,
    );
  });
}

type ServiceOfferings = NonNullable<
  Awaited<ReturnType<typeof getServicesByCartId>>
>;

function getUnappliedServices(item: ServiceOfferings[number]) {
  return {
    ...item,
    services: item.services.filter(
      (service) => !service.offerings.some((offering) => offering.applied),
    ),
  };
}

function getServiceByItemId(offerings: ServiceOfferings, itemId: string) {
  return offerings.find((item: any) => item.item_id === itemId);
}

function applyLabelToAppliedOffers(
  el: Element,
  offering: ServiceOfferings[number],
) {
  const label = el.getAttribute('data-name');
  const sku = el.getAttribute('data-sku');
  if (!label || !sku) return;

  applyLabel(label, sku, offering);
}

function applyLabel(
  parentLabel: string,
  parentSku: string,
  offering: ServiceOfferings[number],
) {
  const skuIdentifier = window.itsServices.skuIdentifier || ';its;';
  const appliedOfferings = offering.services
    .flatMap((s) => s.offerings)
    .filter((o) => o.applied);

  appliedOfferings.forEach((o) => {
    const sku = `${o.code}${skuIdentifier}${parentSku}`;
    const mount = document.querySelector(
      `[data-its-services][data-sku="${sku}"]`,
    );

    if (mount) {
      mount.innerHTML = `<p><span>SKU: ${sku}</span><br><span>For: ${parentLabel}</span></p>`;
    }
  });
}
